import { Image } from '@react-pdf/renderer';
import React from 'react';
import { Flex } from '../../pdf-design-system';

export default function MaximeHerkunftTableSignHeader({ style }) {
  return (
    <Flex style={[{ alignItems: 'center', justifyContent: 'center' }, style]}>
      <Image
        src="https://res.cloudinary.com/bottlebooks/image/upload/v1652015805/pdf-objects/MaximeHerkunft/MaximeHerkunftBottleshowLogo.jpg"
        style={{ width: '12cm' }}
      />
    </Flex>
  );
}
